import { ICategoryInfo } from '../category';

const FLAT_TYPES = [
  'flat', // Квартира
  'newBuildingFlat', // Квартира в новостройке
  'room', // Комната
  'flatShare', // Доля в квартире
  'bed', // Койко-место
];

const SUBURBAN_TYPES = [
  'house', // Дом/Дача
  'cottage', // Коттедж
  'townhouse', // Таунхаус
  'houseShare', // Часть дома
  'land', // Участок ???
];

export const getObjectType = ({ objectType, propertyType }: ICategoryInfo) => {
  switch (true) {
    case propertyType === 'commercial':
      return 'commercial';

    case FLAT_TYPES.includes(objectType):
      return 'flat';

    case SUBURBAN_TYPES.includes(objectType):
      return 'suburban';

    default:
      return null;
  }
};
